import "./index.scss";

import React from "react";
import Counter from "./Counter";
import Form from "./Form";
import Success from "./Success";

const Countdown = ({ type, isShown, setIsSuccess }) => {
  return (
    <div className={`countdown ${isShown && "countdown--show"}`}>
      <h2 className={`countdown__title`}>
        MA <span className={`countdown__type`}>{type}</span>
        {type === "gallery" ? " macOS" : ""} app is launching in…
      </h2>
      <Counter />
      <Form setIsSuccess={setIsSuccess} isShown={isShown} type={type} />
    </div>
  );
};

export default Countdown;
